module.exports = __webpack_public_path__ + "static/media/walk_kids_map_important.a734c98c.svg";